import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import Loader from 'app/components/Loader/Loader.jsx';
import api from 'app/core/api/api.js';
const WikiFallback = (props) => {
    const { articleId } = props.match.params;
    useEffect(() => {
        if (articleId) {
            api.articles.fetchOne(articleId).then((article) => {
                window.location.href = `/assets-wiki/${article.asset}/${articleId}`;
            });
        }
        else {
            window.location.href = '/assets-wiki';
        }
    }, []);
    return _jsx(Loader, {});
};
export default WikiFallback;
